// extracted by mini-css-extract-plugin
export default {"Category":"Category__nDyur","date":"date__Bydgu","content":"content__XJEac","time":"time__WGrbR","yesno":"yesno__UbLUf","text":"text__lNQep","number":"number__s1Gev"};